class MFooter extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.mobileAccordion = this.querySelector(".m-footer--accordion");
    const mobileStickyBar = document.querySelector(".m-mobile-sticky-bar");

    if (this.mobileAccordion) {
      this.setupAccessibleAccordion();
      this.ensureMobileAccordion();

      this.mobileAccordion.addEventListener("click", (event) => {
        if (!event.target.closest(".m-accordion--item-button")) return;
        requestAnimationFrame(() => this.syncAccordionAccessibility());
      });

      this.mobileAccordion.addEventListener("keydown", (event) => {
        const button = event.target.closest(".m-accordion--item-button");
        if (!button || !window.matchMedia("(max-width: 767px)").matches) return;
        if (event.repeat || (event.key !== "Enter" && event.key !== " ")) return;
        event.preventDefault();
        button.click();
      });

      document.addEventListener("matchMobile", () => {
        this.ensureMobileAccordion();
        this.syncAccordionAccessibility();
      });
      document.addEventListener("unmatchMobile", () => this.syncAccordionAccessibility());
    }

    // Set mobile stickybar height
    if (mobileStickyBar) {
      document.documentElement.style.setProperty("--mobile-sticky-bar-height", `${mobileStickyBar.offsetHeight}px`);
      document.addEventListener("matchMobile", () => {
        document.documentElement.style.setProperty("--mobile-sticky-bar-height", `${mobileStickyBar.offsetHeight}px`);
      });
      document.addEventListener("unmatchMobile", () => {
        document.documentElement.style.setProperty("--mobile-sticky-bar-height", `${mobileStickyBar.offsetHeight}px`);
      });
    }
  }

  ensureMobileAccordion() {
    if (!this.mobileAccordion || !window.matchMedia("(max-width: 767px)").matches || this.acc) return;
    this.acc = new MinimogLibs.Accordion(this.mobileAccordion, { presetContentHeight: true, onload: true });
  }

  setupAccessibleAccordion() {
    this.mobileAccordion.querySelectorAll(".m-accordion--item").forEach((item, index) => {
      const button = item.querySelector(".m-accordion--item-button");
      const content = item.querySelector(".m-accordion--item-content");
      if (!button || !content) return;

      if (!button.id) button.id = `FooterAccordionTrigger-${index}`;
      if (!content.id) content.id = `${button.id}-content`;
      button.setAttribute("aria-controls", content.id);
      if (content.matches("ul, ol")) {
        content.removeAttribute("role");
      } else {
        content.setAttribute("role", "region");
      }
      content.setAttribute("aria-labelledby", button.id);
    });

    this.syncAccordionAccessibility();
  }

  syncAccordionAccessibility() {
    const isMobile = window.matchMedia("(max-width: 767px)").matches;

    this.mobileAccordion.querySelectorAll(".m-accordion--item").forEach((item) => {
      const button = item.querySelector(".m-accordion--item-button");
      const content = item.querySelector(".m-accordion--item-content");
      if (!button || !content) return;

      if (!isMobile) {
        button.setAttribute("aria-expanded", "true");
        button.setAttribute("aria-disabled", "true");
        button.setAttribute("tabindex", "-1");
        content.setAttribute("aria-hidden", "false");
        content.removeAttribute("inert");
        return;
      }

      const isOpen = item.classList.contains("open");
      button.setAttribute("aria-expanded", String(isOpen));
      button.removeAttribute("aria-disabled");
      button.removeAttribute("tabindex");
      content.setAttribute("aria-hidden", String(!isOpen));
      if (isOpen) {
        content.removeAttribute("inert");
      } else {
        content.setAttribute("inert", "");
      }
    });
  }
}
customElements.define("m-footer", MFooter);
